module.exports = __webpack_public_path__ + "img/tainted_farm_small.4bc8c4ad.png";